import { jsxs as l, jsx as e } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#internet_explorer-colored_svg__a)", children: /* @__PURE__ */ e("g", { clipPath: "url(#internet_explorer-colored_svg__b)", children: /* @__PURE__ */ e(
        "path",
        {
          fill: "#1EBBEE",
          d: "M23.944 12.582c0-1.934-.493-3.755-1.345-5.348 3.7-8.42-3.924-7.168-4.373-7.168-1.57.318-3.14.83-4.484 1.479-5.158-.063-9.642 2.73-11.1 8.534 2.69-3.072 4.597-4.324 5.718-4.78-.235.217-.47.445-.706.672-1.794 1.82-3.252 3.641-4.485 5.576-.953 1.706-2.018 3.185-2.579 5.12-3.027 11.15 6.503 6.485 7.849 5.689a10.54 10.54 0 0 0 4.82 1.126c4.71 0 8.745-3.072 10.203-7.282h-5.718c-2.69 4.324-9.081 2.39-9.305-2.275H23.91c.059-.467.09-.934.09-1.366zm-2.018-10.81c.93.638 1.682 1.593.392 5.007-1.233-2.048-3.027-3.641-5.27-4.438.999-.489 3.476-1.479 4.934-.569zM2.082 22.367c-.763-.785-.897-2.73.784-6.258a10.73 10.73 0 0 0 4.71 5.803c-1.088.603-3.925 1.935-5.494.376zM8.36 10.99c.086-2.503 2.242-4.551 4.933-4.551s4.821 2.048 4.933 4.551H8.36"
        }
      ) }) }),
      /* @__PURE__ */ l("defs", { children: [
        /* @__PURE__ */ e("clipPath", { id: "internet_explorer-colored_svg__a", children: /* @__PURE__ */ e("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }),
        /* @__PURE__ */ e("clipPath", { id: "internet_explorer-colored_svg__b", children: /* @__PURE__ */ e("path", { fill: "#fff", d: "M0 0h24v24H0z" }) })
      ] })
    ]
  }
);
export {
  t as default
};
